import classnames from "classnames"
import { ReactComponent as Button } from "../src/assets/icons/button.svg"
import { ReactComponent as Quotation } from "../src/assets/icons/quotation.svg"
import { ReactComponent as Twitter } from "../src/assets/icons/twitter.svg"
import { ReactComponent as Whatsapp } from "../src/assets/icons/whatsapp.svg"
import "./App.css"
import useQuoteFetcher from "./hooks/useQuoteFetcher"

function App() {
  const {
    quote,
    author,
    currentQuoteIndex,
    handleNextQuote,
    handlePreviousQuote,
    shareOnTwitter,
    shareOnWhatsApp,
    loading,
  } = useQuoteFetcher("http://localhost:4000/quotes")
  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <header>
          <div className="top-strip" />
          <div className="container">
            <div className="quotation-box ">
              <Quotation />
              <div className="quote">
                <p>{quote}</p>
                <span>- {author}</span>
              </div>
              <div className="bottom-navigation">
                <div>
                  <Button
                    onClick={handlePreviousQuote}
                    className={classnames(
                      "rotate cp",
                      currentQuoteIndex < 1 && "disabled-button"
                    )}
                  />
                  <Button className="cp" onClick={handleNextQuote} />
                </div>
                <div className="share">
                  <span>Share At:</span>
                  <Twitter
                    title="Post this quote on twitter!"
                    onClick={shareOnTwitter}
                    className="cp"
                  />
                  <Whatsapp
                    title="Post this quote on WhatsApp!"
                    onClick={shareOnWhatsApp}
                    className="cp"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-strip" />
        </header>
      )}
    </div>
  )
}

export default App
